import './app.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Brandguidlanding from './components/BrandGuidline/Brandguidlanding.js';
import { Chatandpaylanding } from './components/Chatandpay/Chatandpaylanding.js';
import Buildgroup from './components/Browssecurley/Buildgroup.js';
import { Browssecurlylanding } from './components/Browsesecurlylanding/Browssecurlylanding.js';
import { Aboutuslanding } from './components/Aboutus/Aboutuslanding.js';
import { Createrprofile } from './components/createprofile/Createprofile.js';
import Whitepaperlanding from './components/whitepaper/Whitepaperlanding.js';
import Storagelanding from './components/Storage/Storagelanding.js';
import Roadmap from './components/Roadmap/Roadmap.js';
import Blog from './components/blog/Blog.js';
import Detailpage from './components/Detailpage/Detailpage.js';
import Homepage from './components/Homepage/Homepage.js';
import Contactus from './components/Contactus/Contactus.js';
import Termsofuse from './components/Termsofuse/Termsofuse.js';
import Privacypolicy from './components/Privacypolicy/Privacypolicy.js';
import LaunchModals from './components/LaunchModals/LaunchModals.js';
import Loader from './utils/loader.js';
import { useEffect, useState } from 'react';
import Support from './components/Support/Support.js';
import Walletlanding from './components/Wallet/Walletlanding.js';


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");
    if (hasVisited) {
      setLoading(false);
    } else {
      localStorage.setItem("hasVisited", "true");
      const timer = setTimeout(() => {
        setLoading(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, []);
  return (
    <>
    {
      loading && (<Loader />)
    }
    
      <Router>
        <Routes>
          <Route exact path='/' element={<Homepage />} />
          <Route exact path='/feature' element={<Landing />} />
          <Route exact path='/buildgroup' element={<Buildgroup />} />
          <Route exact path='/browsesecurely' element={<Browssecurlylanding />} />
          <Route exact path='/brandguidelines' element={<Brandguidlanding />} />
          <Route exact path='/chatandpay' element={<Chatandpaylanding />} />
          <Route exact path='/aboutus' element={<Aboutuslanding />} />
          <Route exact path='/createprofile' element={<Createrprofile />} />
          <Route exact path='/whitepaper' element={<Whitepaperlanding />} />
          <Route exact path='/storage' element={<Storagelanding />} />
          <Route exact path='/roadmap' element={<Roadmap />} />
          <Route exact path='/blog' element={<Blog />} />
          <Route exact path='/blogdetail/:id/:idTwo' element={<Detailpage />} />
          <Route exact path='/contactus' element={<Contactus />} />
          <Route exact path='/termofuse' element={<Termsofuse />} />
          <Route exact path='/privacypolicy' element={<Privacypolicy />} />
          <Route exact path='/support/:section' element={<Support />} />
          <Route exact path='/wallet' element={<Walletlanding />} />
        </Routes>
      </Router>
      <LaunchModals />
    </>
  );
}

export default App;